import { LoadingOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Flex,
  Form,
  Select,
  Spin,
  Typography,
  message,
} from "antd";
import { createAttachedSignature } from "crypto-pro";
import { nanoid } from "nanoid";
import { ReactElement, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  API_AUTH_CSP,
  TypeInitialState,
} from "../../../store/slice/authSliceLogin/authSliceLogin";
import { useThunkActionLoadingState } from "../../../utils/Hooks/useThunkActionLoadingState";

import classes from "./RegistrationClientForm.module.css";

const { Text } = Typography;

interface IonFinish {
  thumbprint: string;
  CSP_REG: boolean;
}

export function RegistrationClientForm(): ReactElement {
  const CSP = useSelector(
    (state: { authSlice: TypeInitialState }) => state.authSlice.CSP,
  );

  const [personalDataProcessingAgreement, setPersonalDataProcessingAgreement] =
    useState(false);
  const [privacyPolicyAgreement, setPrivacyPolicyAgreement] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [form] = Form.useForm();

  const { isFetching, sendQuery } = useThunkActionLoadingState();

  const [searchParams] = useSearchParams();

  function onFinish(CSP_VALUE: IonFinish) {
    if (!personalDataProcessingAgreement) {
      message.error("Необходимо соглашение на обработку персональных данных");
      return;
    }

    if (!privacyPolicyAgreement) {
      message.error("Необходимо соглашение с политикой конфиденциальности");
      return;
    }
    const TextThumbprint = nanoid();
    const { thumbprint } = CSP_VALUE;

    createAttachedSignature(thumbprint, TextThumbprint).then(async (r) => {
      const referralCode = searchParams.get("referral_code");
      await sendQuery(
        API_AUTH_CSP({
          thumbprint: r,
          type: "registration",
          referral_code: referralCode ? referralCode : undefined,
        }),
      );
    });
  }

  const ecpOptions = CSP?.CSP_FILTER?.map((item, index: number) => {
    if (item.inn_ul) {
      return {
        key: index,
        value: `${item.thumbprint}`,
        label: `${item.owner} ИНН-${item.inn_ul}`,
      };
    }
    return {
      key: index,
      value: `${item.thumbprint}`,
      label: `${item.owner} ИНН-${item.inn}`,
    };
  });

  const regBtnChild = isFetching ? (
    <Spin
      indicator={<LoadingOutlined className="loader-white" spin />}
      size="small"
    />
  ) : (
    "Зарегистрироваться"
  );

  return (
    <Form
      onFieldsChange={(_undefined, allFields) => {
        const allFieldsFilled = allFields?.every(
          (field) =>
            field.value !== undefined &&
            field.value !== "" &&
            field.value !== false,
        );
        setDisableBtn(!allFieldsFilled);
      }}
      onFinish={onFinish}
      form={form}
      name="CSP_REGISTER"
      className={classes.formContainer}
    >
      <Text className={classes.cspSelectLabel}>Выберите ЭЦП</Text>
      <Form.Item name={"thumbprint"} className={classes.cspSelect}>
        <Select size="large" options={ecpOptions} />
      </Form.Item>

      <Flex gap={16} vertical className={classes.agreementItemContainer}>
        <Flex gap={10} align="center">
          <Checkbox
            checked={personalDataProcessingAgreement}
            onChange={(e) => {
              setPersonalDataProcessingAgreement(e.target.checked);
            }}
            style={{ margin: "-3px 0 0 0" }}
          />

          <Text>
            {"Я даю согласие на обработку "}
            <a href={`/agreementDataProcessing`} target="_blank">
              персональных данных
            </a>
          </Text>
        </Flex>

        <Flex gap={10} align="center">
          <Checkbox
            checked={privacyPolicyAgreement}
            onChange={(e) => {
              setPrivacyPolicyAgreement(e.target.checked);
            }}
            style={{ margin: "-3px 0 0 0" }}
          />

          <Text>
            {"Я согласен с "}
            <a href={`/agreementPrivacyPolicy`} target="_blank">
              политикой конфиденциальности
            </a>
          </Text>
        </Flex>
      </Flex>

      <Button
        size="large"
        disabled={disableBtn || isFetching}
        htmlType="submit"
        color="primary"
        variant="solid"
        className={classes.regSubmitBtn}
      >
        {regBtnChild}
      </Button>
    </Form>
  );
}
